
<template>
  <div>
    <!-- 个人业绩表单开始 -->
    <div class="search_item topIS">
      <div class="item_search_lb">是否显示离职人员业绩:</div>

      <a-select
        @change="getPerformanceList"
        v-model="isDimission"
        style="width: 220px"
        placeholder="是否显示离职人员业绩"
      >
        <a-select-option value="Y"> 是 </a-select-option>
        <a-select-option value="N"> 否 </a-select-option>
      </a-select>

    </div>
    <dl class="search_title" v-if="type === 3">
      <div class="search_top">
        <dd class="search_item mr20">
          <label class="item_search_lb">员工：</label>
          <div class="item_search_in">
            <a-tree-select
              v-model="queryParam.teamId"
              :tree-data="deptOptions"
              placeholder="部门"
              :replaceFields="replaceFields"
              :dropdown-style="{ maxHeight: '300px', overflow: 'auto' }"
              allowClear
              tree-default-expand-all
              @change="handleChangeTree_achiev"
              style="width: 150px"
            >
            </a-tree-select>
            -

            <a-select
              v-model="queryParam.userId"
              @dropdownVisibleChange="handleOption_achiev($event)"
              placeholder="人员"
              style="width: 130px"
            >
              <a-select-option v-for="item in userList" :key="item.userId" :value="item.userId">
                {{ item.nickName }}
              </a-select-option>
            </a-select>
          </div>
        </dd>
        <dd class="search_item">
          <label class="item_search_lb">日期：</label>
          <div class="item_search_in">
            <a-date-picker
              class="mr20"
              v-model="queryParam.startDate"
              :disabled-date="disabledStartDate"
              show-time
              valueFormat="YYYY-MM-DD"
              format="YYYY-MM-DD"
              placeholder="开始时间"
              @openChange="handleStartOpenChange"
            />
            <a-date-picker
              class="mr20"
              v-model="queryParam.endDate"
              :disabled-date="disabledEndDate"
              show-time
              valueFormat="YYYY-MM-DD"
              format="YYYY-MM-DD"
              placeholder="结束时间"
              :open="endOpen"
              @openChange="handleEndOpenChange"
            />
          </div>
        </dd>

        <div style="display:flex;align-items:center">
          <a-button class="mr20" @click="getList">查询</a-button>
          <a-button
            type="default"
            class="btn_export mr20"
            @click="handleExport(1)"
            v-hasPermi="['statistics:comprehensiveStatistics:performanceStatistics']"
          >
            <a-icon type="download" />业绩统计
          </a-button>

          <a-button
            type="default"
            class="btn_export mr20"
            @click="handleExport(2)"
            v-hasPermi="['statistics:comprehensiveStatistics:performanceStatistics']"
          >
            <a-icon type="download" />业绩结算
          </a-button>

          <a-button
            type="default"
            class="btn_export"
            @click="exportHandle"
            v-hasPermi="['statistics:comprehensiveStatistics:export']"
          >
            <a-icon type="download" />导出
          </a-button>
        </div>
      </div>
      <div class="search_bottom">
        <div class="item_search">
          <a-radio-group default-value="week" @change="updateDateHandle" v-model="radioDate" button-style="solid">
            <a-radio-button value="week"> 本周 </a-radio-button>
            <a-radio-button value="month"> 本月 </a-radio-button>
            <a-radio-button value="quarter"> 本季 </a-radio-button>
            <a-radio-button value="year"> 本年 </a-radio-button>
          </a-radio-group>
        </div>
      </div>
    </dl>
    <!-- 个人业绩表单结束 -->

    <!-- 小组业绩表单开始 -->
    <dl class="search_title" v-if="type === 2">
      <div class="search_top">
        <dd class="search_item mr20">
          <label class="item_search_lb">门店：</label>
          <div class="item_search_in">
            <a-select class="w120" placeholder="请选择门店" v-model="queryParam.storeId" @change="storeChange">
              <a-select-option :value="item.deptId" v-for="item in dept" :key="item.deptId">
                {{ item.deptName }}
              </a-select-option>
            </a-select>
          </div>
        </dd>
        <dd class="search_item mr20">
          <label class="item_search_lb">日期：</label>
          <div class="item_search_in">
            <a-date-picker
              class="mr20"
              v-model="queryParam.startDate"
              :disabled-date="disabledStartDate"
              show-time
              valueFormat="YYYY-MM-DD"
              format="YYYY-MM-DD"
              placeholder="开始时间"
              @openChange="handleStartOpenChange"
            />
            <a-date-picker
              class="mr20"
              v-model="queryParam.endDate"
              :disabled-date="disabledEndDate"
              show-time
              valueFormat="YYYY-MM-DD"
              format="YYYY-MM-DD"
              placeholder="结束时间"
              :open="endOpen"
              @openChange="handleEndOpenChange"
            />
          </div>
        </dd>
        <div style="display:flex;align-items:center">
          <a-button @click="getList">查询</a-button>
          <a-button
            type="default"
            class="btn_export"
            @click="exportHandle"
            v-hasPermi="['statistics:comprehensiveStatistics:export']"
          >
            <a-icon type="download" />导出
          </a-button>
        </div>
      </div>
      <div class="search_bottom">
        <div class="item_search">
          <a-radio-group default-value="week" @change="updateDateHandle" v-model="radioDate" button-style="solid">
            <a-radio-button value="week"> 本周 </a-radio-button>
            <a-radio-button value="month"> 本月 </a-radio-button>
            <a-radio-button value="quarter"> 本季 </a-radio-button>
            <a-radio-button value="year"> 本年 </a-radio-button>
          </a-radio-group>
        </div>
      </div>
    </dl>
    <!-- 小组业绩表单结束 -->

    <!-- 门店业绩表单开始 -->
    <dl class="search_title" v-if="type === 1">
      <div class="search_top">
        <dd class="search_item">
          <label class="item_search_lb">日期：</label>
          <div class="item_search_in">
            <a-date-picker
              class="mr20"
              v-model="queryParam.startDate"
              :disabled-date="disabledStartDate"
              show-time
              valueFormat="YYYY-MM-DD"
              format="YYYY-MM-DD"
              placeholder="开始时间"
              @openChange="handleStartOpenChange"
            />
            <a-date-picker
              class="mr20"
              v-model="queryParam.endDate"
              :disabled-date="disabledEndDate"
              show-time
              valueFormat="YYYY-MM-DD"
              format="YYYY-MM-DD"
              placeholder="结束时间"
              :open="endOpen"
              @openChange="handleEndOpenChange"
            />
          </div>
        </dd>
        <div style="display:flex;align-items:center">
          <a-button @click="getList">查询</a-button>
          <a-button
            type="default"
            class="btn_export"
            @click="exportHandle"
            v-hasPermi="['statistics:comprehensiveStatistics:export']"
          >
            <a-icon type="download" />导出
          </a-button>
        </div>
      </div>
      <div class="search_bottom">
        <div class="item_search">
          <a-radio-group default-value="date" @change="updateDateHandle" v-model="radioDate" button-style="solid">
            <a-radio-button value="week"> 本周 </a-radio-button>
            <a-radio-button value="month"> 本月 </a-radio-button>
            <a-radio-button value="quarter"> 本季 </a-radio-button>
            <a-radio-button value="year"> 本年 </a-radio-button>
          </a-radio-group>
        </div>
      </div>
    </dl>

  </div>

</template>

<script>
import { treeSelectMixin } from '@/mixin/treeSelect'

export default {
    props: {
        // 个人 小组 门店
        type: {
            type: Number,
            default: 0
        },
        queryParam: {
            type: Object,
            default: () => ({})
        },
        // radioDate: {
        //     type: String,
        //     default: ''
        // },
        endOpen: {
            type: Boolean,
            default: false
        },
        dept: {
            type: Array,
            default: () => []
        }
    },
    watch: {
        queryParam: {
            handler (val) {},
            deep: true,
            immediate: true
        },
        dept: {
            handler (val) {},
            deep: true,
            immediate: true
        }
    },
    mixins: [treeSelectMixin],
    data () {
        return {
          radioDate: 'week',
          isDimission: 'N' //	是否显示离职人员业绩 字典表类型：sys_yes_no
        }
    },

    methods: {
        init () {
            this.radioDate = 'week'
      },
      getPerformanceList () {
        this.$emit('handleChangeIsDimission', this.isDimission)
      },
        disabledStartDate (startValue) {
            const endValue = this.queryParam.endDate
            if (!startValue || !endValue) {
                return false
            }
            return startValue.valueOf() >= new Date(endValue).valueOf()
        },
        disabledEndDate (endValue) {
            const startValue = this.queryParam.startDate
            if (!endValue || !startValue) {
                return false
            }
            return endValue.valueOf() <= (new Date(startValue).valueOf() - 1000 * 60 * 60 * 24)
        },
        handleStartOpenChange (val) {
            this.$emit('handleStartOpenChange', val)
        },
        handleEndOpenChange (val) {
            this.$emit('handleEndOpenChange', val)
        },
        getList () {
            this.$emit('getList')
        },
        updateDateHandle () {
            this.$emit('updateDateHandle', this.radioDate)
        },
        handleExport (val) {
            this.$emit('handleExport', val)
        },
        exportHandle () {
            this.$emit('exportHandle')
        },
        storeChange () {
            this.$emit('storeChange')
        }
    }
}
</script>

<style lang="less" scoped>
.mr20{
  margin-right: 20px;
}

.search_title{
  .search_top{
    display: flex;
    flex-wrap: wrap;
    .search_item{
      display: flex;
      justify-content: space-around;
      align-items: center;
    }
  }
  .search_bottom{
    display: flex;
    margin-top: 15px;
    justify-content: flex-start;
  }
}
.topIS{
  margin-bottom:20px;
  display: flex;
  align-items: center;
}

.topIS .item_search_lb{
  margin-right: 10px;
}
</style>
